<template>
    <div class="horse-edit-main-other-data flex flex-column mt-2 gap-3">
<!--        <div v-if="!imported" class="flex gap-3 align-items-center">-->
<!--            <div class="label mt-1">{{ $t('message.horseEdit.main.genotypeStatusLabel') }}:</div>-->
<!--            <div v-if="horse.dnasampleExists" class="value">-->
<!--                <i class="pi pi-check font-bold"/>-->
<!--            </div>-->
<!--            <div v-else class="value">-->
<!--                <i class="pi pi-times font-bold"/>-->
<!--            </div>-->
<!--        </div>-->
        <div class="flex">
            <CustomInputTextArea name="notes" :label="$t('message.horseEdit.main.notes')"
                                 v-model="horse.notes" class="w-full" :disabled="disableEdit"/>
        </div>
    </div>
</template>

<script>

import CustomInputTextArea from "@/components/form/CustomInputTextArea.vue";

export default {
    name: "HorseEditMainOtherData",
    components: {
        CustomInputTextArea,
    },

    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        imported: {
            type: Boolean,
            default: false,
        },
        disableEdit: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["update:modelValue"],

    computed: {
        horse: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },
};
</script>

<style lang="scss">
@import "../../../../../assets/theme/mytheme/variables";
.horse-edit-main-other-data {
    .label {
        font-size: 18px;
        text-transform: uppercase;
    }

    .value {
        font-family: var(--decor-font-family);
        font-size: 20px;
    }
}
</style>
